import { CircleFlag } from 'react-circle-flags';
import { Box, BoxProps, Circle } from '@chakra-ui/react';
import { Locale, useLocale } from '@ae/shared';

export const UICountryFlag = ({ ...props }: BoxProps) => {
  const locale = useLocale();

  const countryCode = () => {
    switch (locale) {
      case Locale.Fr:
      case Locale.Nl:
        return 'be';
      case Locale.En:
        return 'gb';
      case Locale.De:
        return 'de';
      default:
        return '';
    }
  };

  return (
    <Box
      bgColor="white"
      borderRadius="50px"
      height="26px"
      width="26px"
      display="flex"
      justifyContent="center"
      alignItems="center"
      p="2px"
      {...props}
    >
      <Circle size="26px" p="2px" bgColor="white">
        <CircleFlag countryCode={countryCode()} />
      </Circle>
    </Box>
  );
};
